import React from "react";
import "../styles/Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <h1 className="text">
        This website was made with React and designed on Figma.{" "}
      </h1>
    </footer>
  );
}

export default Footer;
